/*
 * @Author: 丨小小风离丨
 * @Date: 2024-05-13 21:05:22
 * @LastEditTime: 2025-01-08 19:55:51
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\components\selectHtml\index.tsx
 * @Description: 
 */
import { Select } from 'antd';
import './index.scss';

interface Option {
  label: string;
  value: any;
}

interface MySelectProps {
  options: any[];
  value?: any;
  onChange?: (value: any) => void;
  disabled?: boolean;
  placeholder?: string;
  width?: string;
}

const MySelect = ({ options, value, onChange, placeholder, width }: MySelectProps) => {

  return (
    <>
      <Select
        value={value || null}
        placeholder={placeholder}
        onChange={onChange}
        className="CommonSelect"
        style={{ width: width || '160px' }}
        getPopupContainer={(node) => node.parentNode}
      >
        {options?.map(
          (item: any, index: number) => {
            return (
              <Select.Option
                label={item?.name || item?.label || ''}
                value={item?.value}
                key={item?.value || index}
              >
                {item?.name || item?.label || ''}
              </Select.Option>
            );
          }
        )}
      </Select>
    </>
  );
};

export default MySelect;
